import {
    OBTENER_TERMINOS_Y_CONDICIONES,
    OBTENER_POLITICAS_DE_PRIVACIDAD,
    OBTENER_TERMINOS_ACEPTADOS,
    OBTENER_POLITICAS_ACEPTADAS,
    ACEPTAR_TERMINOS_Y_CONDICIONES,
    ACEPTAR_POLITICAS_DE_PRIVACIDAD,
    PROGRESS
} from 'types/context';

export default (state, action) => {
    switch (action.type) {
        case OBTENER_TERMINOS_Y_CONDICIONES:
            return {
                ...state,
                terminosYCondiciones: action.payload ? action.payload : null
            }
        case OBTENER_POLITICAS_DE_PRIVACIDAD:
            return {
                ...state,
                politicasDePrivacidad: action.payload ? action.payload : null
            }
        case OBTENER_TERMINOS_ACEPTADOS:
            return {
                ...state,
                terminosAceptados: action.payload
            }
        case OBTENER_POLITICAS_ACEPTADAS:
            return {
                ...state,
                politicasAceptadas: action.payload
            }
        case PROGRESS:
            return {
                ...state,
                progress: action.payload
            }
        default:
            return state;
    }
}